import { createFileRoute } from '@tanstack/react-router';
import { eventDetailsQuery } from '@/api/queries';
import { EventDetails, EventDetailsSkeleton } from './-components/EventDetails';

export type EventDetailsSearch = {
  /** Open the Bet Builder tab when the event supports it. */
  offer?: 'betbuilder';
};

/** Deepest level of the legacy five-segment URL model. */
export const Route = createFileRoute('/sports/$sport/$category/$tournament/$eventId')({
  validateSearch: (search: Record<string, unknown>): EventDetailsSearch => ({
    offer: search.offer === 'betbuilder' ? 'betbuilder' : undefined,
  }),
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(eventDetailsQuery(params.eventId)),
  pendingComponent: EventDetailsSkeleton,
  component: EventDetailsPage,
});

function EventDetailsPage() {
  const { sport, category, tournament, eventId } = Route.useParams();
  const { offer } = Route.useSearch();
  return (
    <EventDetails
      eventId={eventId}
      sport={sport}
      category={category}
      tournament={tournament}
      initialOffer={offer}
    />
  );
}
